import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://lpcroolcwupjyefjoflb.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxwY3Jvb2xjd3VwanllZmpvZmxiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgxNTA5MDcsImV4cCI6MjA5MzcyNjkwN30.8KUHM2EUHmjlibEx70lprgyl5gG8V8myxitGj60TIz4";

export const supabase = createClient(supabaseUrl, supabaseKey);
